import React from 'react'
// components
import Actions from 'components/PageComponents/Actions'
import ActionsPageAPI from 'containers/Actions/Register/layers/API'
import TableManagementProvider from 'containers/Search/layers/BL'

const ActionsContainer: React.FC = () => (
  <TableManagementProvider>
    <ActionsPageAPI>
      <Actions />
    </ActionsPageAPI>
  </TableManagementProvider>
)

export default ActionsContainer
